import { gql } from "apollo-boost";

export const GET_ACADEMICPERIOD = gql`
  query getAcademicPeriod($id: ID!) {
    getAcademicPeriod(
      id: $id
    ) {
      id
      periodCode
      year
      semester
    }
  }
`;

export const GET_ACADEMICPERIODS = gql`
  query getAcademicPeriods {
    getAcademicPeriods {
      id
      periodCode
      year
      semester
      isDisabled
      label: periodCode
    }
  }
`;

export const ADD_ACADEMICPERIOD = gql`
  mutation addAcademicPeriod(
    $periodCode: String!,
    $year: String,
    $semester: Int!
  ) {
    addAcademicPeriod (
      periodCode: $periodCode,
      year: $year,
      semester: $semester
    ) {
      id
      periodCode
      year
      semester
    }
  }
`;

export const UPDATE_ACADEMICPERIOD = gql`
  mutation updateAcademicPeriod(
    $id: ID!,
    $periodCode: String!,
    $year: String,
    $semester: Int!
  ) {
    updateAcademicPeriod (
      id: $id,
      periodCode: $periodCode,
      year: $year,
      semester: $semester
    ) {
      id
      periodCode
      year
      semester
    }
  }
`;

export const DELETE_ACADEMICPERIOD = gql`
  mutation deleteAcademicPeriod(
    $id: ID!
  ) {
    deleteAcademicPeriod (
      id: $id
    ) {
      id
      periodCode
      year
      semester
    }
  }
`;


/* TYPES

type AcademicPeriod {
  id: ID!
  periodCode: String!
  year: String!
  semester: Int!
  isDisabled: Boolean!
  createdAt: String!
  updatedAt: String!
  createdBy: User
  updatedBy: User
}

*/
